import React, { useState, useEffect } from 'react';
import { X, Trophy, Save } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (data: any) => void;
}

export const CreateClassificationModal: React.FC<Props> = ({ isOpen, onClose, onCreate }) => {
  const { currentUser } = useAuth();
  const [name, setName] = useState('');
  const [club, setClub] = useState('');
  const [clubs, setClubs] = useState<any[]>([]);

  const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";
  const token = localStorage.getItem('tt_auth_token');

  useEffect(() => {
    if (isOpen) {
      setName('');
      setClub((currentUser as any)?.clubId || '');
      fetchClubs();
    }
  }, [isOpen]);

  const fetchClubs = async () => {
    try {
      const res = await fetch(`${API_URL}/api/clubs`, { headers: { 'Authorization': `Bearer ${token}` }});
      if (res.ok) {
        setClubs(await res.json());
      }
    } catch(e) {}
  };

  const handleSave = () => {
    if (!name.trim()) {
      alert("Nome é obrigatório");
      return;
    }
    onCreate({ name, club });
  };

  if (!isOpen) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: "#1A112C", width: '100%', maxWidth: '500px', borderRadius: '16px', border: '1px solid var(--border-light)', overflow: 'hidden' }}>
        
        {/* Header */}
        <div style={{ padding: '24px', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ background: 'var(--primary-color)', padding: '8px', borderRadius: '8px', color: 'white' }}>
              <Trophy size={20} />
            </div>
            <h2 style={{ color: 'white', margin: 0, fontSize: '18px' }}>Nova Classificação</h2>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>
            <X size={24} />
          </button>
        </div>

        {/* Form */}
        <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div>
            <label style={{ display: 'block', color: 'rgba(255,255,255,0.8)', fontSize: '14px', marginBottom: '8px' }}>Nome da Classificação *</label>
            <input 
              type="text" 
              value={name} 
              onChange={e => setName(e.target.value)} 
              placeholder="Ex: Ranking Interno 2026"
              style={{ width: '100%', padding: '12px 16px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
            />
          </div>
          
          {(currentUser?.role === 'ADMIN' || currentUser?.role === 'GESTOR_COMPETICAO') && (
            <div>
              <label style={{ display: 'block', color: 'rgba(255,255,255,0.8)', fontSize: '14px', marginBottom: '8px' }}>Clube</label>
              <select 
                value={club} 
                onChange={e => setClub(e.target.value)}
                style={{ width: '100%', padding: '12px 16px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: 'white', boxSizing: 'border-box', appearance: 'none' }}
              >
                <option value="" style={{ color: 'black' }}>Todos / Global</option>
                {clubs.map(c => (
                  <option key={c.id} value={c.id} style={{ color: 'black' }}>{c.name}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: '24px', borderTop: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: 'white', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>Cancelar</button>
          <button onClick={handleSave} style={{ padding: '10px 20px', background: 'var(--primary-color)', border: 'none', color: 'white', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Save size={18} /> Criar Classificação
          </button>
        </div>
      </div>
    </div>
  );
};
